export default class Filter {
	constructor(app) {
		this.app = app;

		if (document.getElementById('filter')) {
			this.setup();
		}
	};

	/**
	 * 
	 */
	setup() {
		if (this.app.debug) {
			console.log("Filter started");
		}
		
		this.url = new URL(window.location.href);
		this.filter = [];
		this.sorter = 0;
		this.loader = document.querySelector('.loading__container');
		this.container = document.getElementById('filter-container');
		this.content = document.getElementById('filter-content');
		this.error = document.getElementById('filter-error');
		this.filterCategories = document.querySelectorAll('.filter__categorie');
		// this.sortContainer = document.querySelector('.filter__sort-options');
		this.sorters = document.getElementsByName('filter-confirm--sort');
		this.sortStatus = document.getElementById('sort-status');
		this.resetButton = document.getElementById('filter-reset');
		this.options = [];
		this.contentDelay = 150;
		this.hasScrolled = false;
		
		
		this.filterCategories.forEach((categorie, i) => {
			var alias = categorie.getAttribute('data-categorie');
			var options = document.getElementsByName(alias);
			
			options.forEach((option, l) => {
				option.addEventListener('click', () => this.optionClicked(option));
				if (option.checked) this.setFilterOption(option);
			});
			
			this.options.push(options);
		});
		
		this.sorters.forEach((sorter, i) => {
			if (i == 0) sorter.checked = true;
			sorter.addEventListener('click', () => this.sorterClicked(sorter));
		});
		
		this.sendFilter();
		this.resetButton.addEventListener('click', () => this.reset());
	};
	
	/**
	 * 
	 */
	optionClicked(option) {
		this.wasSet = false;
		this.setFilterOption(option);
		
		if (this.wasSet) {
			option.checked = false;
		}
		
		this.sendFilter();
	}
	
	/**
	 * 
	 */
	sorterClicked(sorter) {
		this.sorter = sorter.value;
		
		var nameElement = document.querySelector('[for=' + sorter.id + '][data-name]');
		this.sortStatus.innerHTML = nameElement.getAttribute('data-name');
		// this.sortContainer.classList.remove('dropdown--open');
		
		this.sendFilter();
	}
	
	/**
	 * 
	 */
	setFilterOption(option) {
		var isSet = false;
		this.filter.forEach((filter, i) => {
			if (filter.categorie == option.name) {
			
				if (filter.option == option.value) {
					this.filter.splice(i);
					this.wasSet = true;
					isSet = true;
					return;
				}
				
				filter.option = option.value;
				isSet = true;
				return;
			}
		});
		
		if (!isSet) {
			this.filter.push({'categorie': option.name, 'option': option.value});
		}
	}
	
	/**
	 * 
	 */
	sendFilter() {
		this.content.innerHTML = "";
		this.error.innerHTML = "";
		this.error.parentNode.style.display = 'none';
		this.container.classList.remove('filter--loaded');
		
		this.sendData(this.url, this.filter);
	}
	
	/**
	 * 
	 */
	sendData(url, data) {
		var searchParams = new URLSearchParams(url.search);
		
		this.addSearchParam(searchParams, 'filter', data);
		this.addSearchParam(searchParams, 'sorter', this.sorter);
		
		url.search = searchParams;
		fetch(url).then((response) => {
			if (response.status == '200') return response.text();
			return false;
		}).then((response) => this.handleReponse(JSON.parse(response)));
	}
	
	/**
	 * 
	 */
	addSearchParam(searchParams, param, data) {
		if (searchParams.has(param)) {
			searchParams.set(param, JSON.stringify(data));
			return;
		}
		
		searchParams.append(param, JSON.stringify(data));
	}
	
	/**
	 * 
	 */
	handleReponse(response) {
		this.content.innerHTML = '';

		setTimeout(() => {
			switch (response.head) {
				case 'content':
					this.successResponse(response);
				break;
				case 'error':
					this.errorResponse(response);
				break;
			}
			
			this.container.classList.add('filter--loaded');
			
			if (response.head == 'content') {
				this.toggleContent(this.content);
			}
		}, 500);
	}
	
	successResponse(response) {
		this.content.innerHTML = JSON.parse(response.body);
		var hash = window.location.hash;
		if (hash && !this.hasScrolled) {
			this.hasScrolled = true;
			this.contentDelay = 0;
			var element = document.querySelector(hash);
			if (element) {
				var position = element.getBoundingClientRect();
				window.scrollTo(position.left, position.top - window.innerHeight * 0.5);
			}
		}
	}
	
	errorResponse(response) {
		this.error.innerHTML = JSON.parse(response.body);
		this.error.parentNode.style.display = '';
	}
	
	/**
	 * 
	 */
	async toggleContent(content) {
		if (!content.children.length) return;
		
		for (var i = 0; i < content.children.length; i++) {
			await this.sleep(this.contentDelay);
			if (this.content.children[i]) {
				this.content.children[i].classList.toggle('tile--loaded');
			}
		}

		var checkButtons = content.querySelectorAll('[type=checkbox]');
		checkButtons.forEach(element => {
			element.addEventListener('click', (event) => {
				checkButtons.forEach((button) => {
					if (button != element) {
						button.checked = false;
					}
				});
			});
		});
	}
	
	/**
	 * 
	 */
	sleep(ms) {
		return new Promise(resolve => setTimeout(resolve, ms));
	}
	
	/**
	 * 
	 */
	reset() {
		this.options.forEach((categorie, i) => {
			categorie.forEach((option, i) => {
				if (option.checked) option.checked = false;
			});
		});
		
		this.filter = [];
		this.sendFilter();
	}
}